"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedlocationpin02sm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedlocationpin02sm` : '') + (description ? ` desc-brandedlocationpin02sm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedlocationpin02sm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedlocationpin02sm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M14 7.5C14 4.72543 13.2291 0 7 0C0.895434 0 0 4.49422 0 7.5C0 11.5 4.63292 16.9942 7 20C9.53319 17.1484 14 11.5 14 7.5Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3 7C3 4.79093 4.79093 3 7 3C9.20907 3 11 4.79093 11 7C11 9.20907 9.20907 11 7 11C4.79093 11 3 9.20907 3 7Z",
    fill: "#DAFCFE"
  }));
};
var _default = exports.default = brandedlocationpin02sm;